import React, { useState } from "react";
import cn from "classnames";
import styles from "./Panel.module.sass"; // Assuming the path is correct relative to the component
import Icon from "../../../components/Icon"; // Adjust path if necessary
import { deleteCenter } from "../../../services/center.service"; // <--- Import deleteCenter
import { showSuccess, showError } from "../../../services/toast.service"; // Adjust path if necessary

const Panel = ({ selectedIds = [], onDeleteSuccess }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  // Gérer la suppression des centres sélectionnés
  const handleDelete = async () => {
    if (selectedIds.length === 0) return;

    setIsDeleting(true);

    try {
      // Supprimer chaque centre sélectionné
      const deletePromises = selectedIds.map(id => deleteCenter(id)); // <--- Call deleteCenter
      await Promise.all(deletePromises);

      showSuccess(`${selectedIds.length} centre(s) supprimé(s) avec succès`); // <--- Updated message

      // Notifier le composant parent pour mettre à jour la liste
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (error) {
      showError(`Erreur lors de la suppression: ${error.message}`);
    } finally {
      setIsDeleting(false);
    }
  };

  // Ne pas afficher le panel si aucun centre n'est sélectionné
  if (selectedIds.length === 0) {
    return null;
  }

  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}>
        <Icon name="check-all" size="24" />
        <span>{selectedIds.length} centre(s)</span> sélectionné(s) {/* <--- Updated text */}
      </div>
      <button
        className={cn("button-stroke-red", styles.button, { [styles.loading]: isDeleting })}
        onClick={handleDelete}
        disabled={isDeleting}
      >
        <Icon name="trash" size="24" />
        <span>{isDeleting ? 'Suppression...' : 'Supprimer'}</span>
      </button>
    </div>
  );
};

export default Panel;